// ModalInput.tsx
import React, { useEffect, useState } from "react";
import styles from "./Modal.module.css";

export interface ModalInputProps {  
  placeholder?: string;
  value?: string;
  onChange: (value: string) => void; // setState 역할
  type?: "text" | "password" | "email" | "number";
  maxLength?: number;
  autoFocus?: boolean;
}

const ModalInput: React.FC<ModalInputProps> = ({  
  placeholder,
  value = "",
  onChange,
  type = "text",
  maxLength,
  autoFocus = false,
}) => {

  // ✅ 내부에서 진짜로 사용하는 값
  const [innerValue, setInnerValue] = useState(value);

  // 만약 부모가 value를 바꾸는 경우를 대비해서(지금 구조에서는 거의 안 쓰이지만)
  useEffect(() => {
    setInnerValue(value);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value;
    setInnerValue(next);     // 내부 상태 업데이트
    onChange?.(next);        // 부모에게도 알려주기 (있으면)
  };

  return (
    <div className={styles.modalInputWrapper}>
      <input
        className={styles.modalInput}
        type={type}
        value={innerValue}
        onChange={handleChange}
        placeholder={placeholder}
        maxLength={maxLength}
        autoFocus={autoFocus}
      />
    </div>
  );
};

export default ModalInput;
